import { render } from "./VideoDetailsCompletionButton.vue?vue&type=template&id=78565b22&ts=true"
import script from "./VideoDetailsCompletionButton.vue?vue&type=script&lang=ts"
export * from "./VideoDetailsCompletionButton.vue?vue&type=script&lang=ts"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__